var React = require('react');

function SoundOffIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FFF","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M18 33.7816721L24 41V24M24 11.6339939V1L10.2 14.7329559H4.0666667C2.4643333 14.7329559 1 16.200401 1 17.7997169v6.1335221C1 25.5356216 2.2312667 27 3.8336 27h4.8330667M30 21c0 2.762615-2.1650907 5-4.8331204 5H24M3 40L39 3"})));
}

SoundOffIcon.defaultProps = {"viewBox":"0 0 40 41"};

module.exports = SoundOffIcon;

SoundOffIcon.default = SoundOffIcon;
